<template>
  <div id="header">
    <div class="navbar navbar-expand-md navbar-dark" style="min-height: 55px; z-index: 100;">
      <div class="navbar-brand wmin-200">
        <a href="/" class="d-inline-block" style="padding: 10px; padding-left: 0px;">
          <img src="/static/images/logo-dark.svg" style="height: 32px; display: block; margin: 0px;" />
        </a>
      </div>

      <div class="d-md-none">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-mobile">
          <i class="icon-tree5"></i>
        </button>
        <button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
          <i class="icon-paragraph-justify3"></i>
        </button>
      </div>
      <div class="collapse navbar-collapse" id="navbar-mobile">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item d-flex align-items-center justify-content-center" v-if="role != null && getEnums.length > 0"><el-tag :closable="false">{{getEnumsDisplay('TypeOfAuthority', role)}}</el-tag></li>
          <li class="nav-item dropdown dropdown-user">
            <a href="javascript:;" @click="requestFullScreen" class="navbar-nav-link menu-link-custom expand-control">
              <i class="fas fa-expand" :style="fullScreen ? 'color:#f22f2f;' : ''"></i>
            </a>
          </li>

          <!-- <li class="nav-item dropdown dropdown-user">
            <a href="javascript:;" @click="usageModal = true" class="navbar-nav-link menu-link-custom notification-control">
              <i class="el-icon-message-solid"></i>
            </a>
          </li> -->

          <li class="nav-item dropdown dropdown-user">
            <a href="javascript:;" @click="accountModal = true" class="navbar-nav-link d-flex align-items-center dropdown-toggle">
              <div class="menu-profile-custom" :style="'background-image: url(' + $store.getters.currentUser.image + ');'"></div>
              <span class="header-fullname">
                <b>{{ $store.getters.currentUser.firstName }}</b>
                {{ $store.getters.currentUser.lastName }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :title="$t('myAccount')" width="550px" :visible.sync="accountModal" class="medium" center append-to-body destroy-on-close>
      <MyAccount @closeDialog="accountModal = false" @close-dialog="accountModal = false" v-if="accountModal"/>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="$t('notifications')" width="80%" :visible.sync="usageModal" class="medium" center append-to-body destroy-on-close>
      <UsageActivity :key="usageModal" @closeDialog="usageModal = false" />
    </el-dialog>
  </div>
</template>

<script>
  import MyAccount from '@/pages/MyAccount';
  import UsageActivity from '../pages/event/UsageActivity';
  import moment from 'moment/min/moment-with-locales';

  export default {
    name: 'Header',
    components: {MyAccount, UsageActivity},
    data() {
      return {
        accountModal: false,
        usageModal: false,
        fullScreen: false,
        moment,
        localStorage,
      };
    },

    async mounted() {
      document.addEventListener('fullscreenchange', () => {
        this.fullScreen = document.webkitIsFullScreen;
      });
      if (window.location.hostname == 'app.holacon.com') {
        var userId = await this.$OneSignal.getUserId();
        if (userId != null && userId != undefined) {
          console.log('userId', userId);
          // await this.$store.dispatch("updatePlayerId", userId);
        }
      }
    },
 
  computed:{
    role(){
      return this.$store.getters.getEventRole;
    },
    getEnums(){
      return this.$store.getters.getEnums;
    },
  },
    methods: {
      logout() {
        localStorage.removeItem('token');
        this.$store.state.user.user = null;
        this.$store.state.user.token = null;
        window.location.href = '/';
      },
      changeLocale(locale) {
        window.location.reload();
        this.$i18n.locale = locale;
        moment.locale(locale);
        localStorage.setItem('lang', locale);
      },

      requestFullScreen() {
        var elem = document.documentElement;
        if (this.fullScreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) {
            /* Firefox */
            document.mozCancelFullScreen();
          } else if (document.webkitExitFullscreen) {
            /* Chrome, Safari and Opera */
            document.webkitExitFullscreen();
          } else if (document.msExitFullscreen) {
            /* IE/Edge */
            document.msExitFullscreen();
          }
        } else {
          if (elem.requestFullscreen) {
            elem.requestFullscreen();
          } else if (elem.mozRequestFullScreen) {
            /* Firefox */
            elem.mozRequestFullScreen();
          } else if (elem.webkitRequestFullscreen) {
            /* Chrome, Safari and Opera */
            elem.webkitRequestFullscreen();
          } else if (elem.msRequestFullscreen) {
            /* IE/Edge */
            elem.msRequestFullscreen();
          }
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Header.vue